import { render, staticRenderFns } from "./Parcela.vue?vue&type=template&id=298d7aa8&scoped=true"
import script from "./Parcela.vue?vue&type=script&lang=js"
export * from "./Parcela.vue?vue&type=script&lang=js"
import style0 from "../../../../css/crud.css?vue&type=style&index=0&id=298d7aa8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298d7aa8",
  null
  
)

export default component.exports